import UserLink from 'src/modules/shared/links/userLink';
import { Element, Section } from 'src/constants/footfall';
import Badge from 'src/components/badge';
import { SupportingMember } from 'src/constants/types';
import { SupportingMembers, SupportingMemberEl, SupportingMemberAvatar, SupportingMemberUser, SupportingMemberLink } from 'src/modules/community/communityAbout/components/sharedStyles';
import { Size } from 'src/components/avatar';
type Props = {
  supportingMembers: SupportingMember[];
};
export default function SupportingMembersList({
  supportingMembers
}: Props) {
  return <SupportingMembers data-sentry-element="SupportingMembers" data-sentry-component="SupportingMembersList" data-sentry-source-file="supportingMembersList.tsx">
      {supportingMembers.map(user => {
      const {
        username,
        userImageHash,
        role
      } = user;
      return <SupportingMemberEl data-testid="supporting-member" key={username}>
            <SupportingMemberAvatar>
              <UserLink avatarSize={Size.Small} signupContext={{
            element: Element.Avatar,
            section: Section.CommunityAbout
          }} user={{
            username,
            userImageHash
          }} />
            </SupportingMemberAvatar>
            <SupportingMemberUser>
              <SupportingMemberLink signupContext={{
            element: Element.UserLink,
            section: Section.CommunityAbout
          }} user={{
            username
          }} />
              <Badge>{role}</Badge>
            </SupportingMemberUser>
          </SupportingMemberEl>;
    })}
    </SupportingMembers>;
}